import React, { useRef } from 'react';

import { ViewableQuestion, ViewableResponse } from '../types/global';
import { upperFirst } from 'lodash';
import { parseInlineMarkdown } from '@/util/parseInlineMarkdown';
import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { RootState } from '@/types/graph';
import { useSelector } from 'react-redux';

interface QuestionProps {
  error?: boolean;
  required?: boolean;
  label?: string | null;
  comment?: string;
  children?: React.ReactNode;
  onClickLabel?: () => void;
  id?: string;
  style?: React.CSSProperties;
  format?: ViewableQuestion['format'];
  responses?: ViewableResponse[];
}

export const Question = ({
  children,
  required,
  label,
  comment,
  onClickLabel,
  id,
  format,
}: QuestionProps) => {
  const containerRef = useRef(null);
  const { mandatoryQuestionsWarning } = useQuestionnaireNavigation();
  const displayFullQueue = useSelector(
    (state: RootState) => state.graph.options.DISPLAY_FULL_QUEUE,
  );

  return (
    <div ref={containerRef} id={id} className="ph-no-capture z-50">
      <div className="question relative mr-6 ml-6 pb-3.5">
        <div className="absolute left-0 top-0 h-0.5 w-20% z-0" />
        {format === 'INFO' ? (
          <div className="rounded-md bg-purple-100/55 px-3 py-2 font-medium text-sm text-purple-800 flex items-center gap-2">
            <p>
              {label &&
                parseInlineMarkdown(upperFirst(label.replace(' ?', '\u00A0?')))}
            </p>
          </div>
        ) : (
          <>
            <div className="flex flex-col gap-2">
              <div
                onClick={onClickLabel}
                className="text-1.5xl nlg:text-2xl font-semibold leading-tight"
              >
                {label &&
                  parseInlineMarkdown(
                    upperFirst(label.replace(' ?', '\u00A0?')),
                  )}
                {required &&
                  (mandatoryQuestionsWarning || displayFullQueue) && (
                    <span className={`text-sm font-medium`}>
                      {' '}
                      (obligatoire)
                    </span>
                  )}
              </div>
              {comment && (
                <div className="text-sm font-light">
                  {parseInlineMarkdown(upperFirst(comment))}
                </div>
              )}
            </div>
            <div className="flex flex-col gap-2 mt-8">{children}</div>
          </>
        )}
      </div>
    </div>
  );
};
